const resources = {
  resources: 'Recursos',
  select_resources: 'Selecciona Recursos',
  select_resources_group: 'Selecciona Grupo',
  select_position: 'Selecciona una posición',
  menu_position: 'Posición del menu',
}

export default resources
